const e = {
  name: "PuppetRun",
  dimensions: { width: 28, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 28 40" style="enable-background:new 0 0 28 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M0,0h12v10.5l5.3,3.5H28v12H17.3L12,29.5V40H0V28h10.7l5.3-3.5v-8.9L10.7,12H0V0z M2,2v8h8V2H2z M2,30v8h8v-8
			H2z M18,24h8v-8h-8V24z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as PuppetRun
};
